export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '恋爱',
    slug: 'romance',
    icon: 'ri-heart-line',
    description: '甜蜜浪漫的恋爱故事，满足你的少女心',
    count: 3,
  },
  {
    id: '2',
    name: '奇幻',
    slug: 'fantasy',
    icon: 'ri-magic-line',
    description: '魔法、龙族与异世界冒险的奇幻旅程',
    count: 3,
  },
  {
    id: '3',
    name: '动作',
    slug: 'action',
    icon: 'ri-sword-line',
    description: '酣畅淋漓的战斗场面与热血剧情',
    count: 2,
  },
  {
    id: '4',
    name: '悬疑',
    slug: 'mystery',
    icon: 'ri-search-eye-line',
    description: '烧脑推理与惊悚悬疑的极致体验',
    count: 2,
  },
  {
    id: '5',
    name: '日常',
    slug: 'slice-of-life',
    icon: 'ri-sun-line',
    description: '温暖治愈的日常生活小故事',
    count: 2,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};